import React, { useState } from "react";
import ThemeSelectorContext from "./ThemeSelectorContext";

const ThemeSelectorContextProvider = ({ children }) => {
  const [theme, setTheme] = useState("default");

  return (
    <ThemeSelectorContext.Provider
      value={{
        theme,
        setTheme,
      }}
    >
      {children}
    </ThemeSelectorContext.Provider>
  );
};

export default ThemeSelectorContextProvider;
